export default "__VITE_ASSET__ecd6e02f__"